<form
  [formGroup]="form"
  (ngSubmit)="confirm()"
  class="flex flex-col">
  <div class="flex flex-col">
    <div class="flex w-full justify-between gap-4 py-4 border-b border-neutral-300">
      <span class="text-[18px] font-black">
        <i
          class="pi pi-file-edit"
          style="font-size: 2rem"></i>
        SUBSANACION DE DESPLIEGUE DE SISTEMA
      </span>
      <div class="flex gap-4">
        <app-buttons
          [label]="'Detalle de subsanación'"
          (click)="goToSummary()" />
        <app-buttons
          [label]="'Volver al paso anterior'"
          (click)="backPage()" />
        <app-buttons
          [label]="'Continuar'"
          [disabled]="form.invalid || hasPendingObservedFieldsInStep()"
          [classes]="'bg-primary-base text-primary-light'"
          (click)="confirm()"
          type="button" />
      </div>
    </div>

    <div class="flex flex-col py-4">
      <span class="font-regular text-[18px]">Paso 2 de 6</span>
      <h2 class="font-bold text-[24px] pb-6">Cumplimiento Reglamento de Inteligencia Artificial (RIA)</h2>

      <div class="flex flex-col relative">
        <label
          class="text-[16px]"
          for="usageInstructions"
          [ngClass]="{ 'relative -top-4': isObserved('usageInstructions') }">
          Instrucciones de uso
          <span *ngIf="highRiskFieldsRequired()">*</span>
        </label>
        <app-observed-field-alert
          *ngIf="isObserved('usageInstructions')"
          class="absolute top-2 left-0"></app-observed-field-alert>
      </div>
      <desy-textarea
        formControlName="usageInstructions"
        placeholder="Identificar la URL donde se puede acceder a las instrucciones de uso del proveedor"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="200"></desy-textarea>
      <ng-container *ngIf="getError(form, 'usageInstructions', formSubmitted()) as error; else usageInstructionsInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #usageInstructionsInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 200 caracteres</span>
      </ng-template>

      <div class="grid grid-cols-2 gap-12">
        <div class="flex flex-col relative">
          <label
            class="text-[16px] mt-4 block"
            for="humanSupervision"
            [ngClass]="{ 'relative -top-4': isObserved('humanSupervision') }">
            Supervisión humana
            <span *ngIf="highRiskFieldsRequired()">*</span>
          </label>
          <app-observed-field-alert
            *ngIf="isObserved('humanSupervision')"
            class="absolute top-6 left-0"></app-observed-field-alert>
          <span class="text-[14px] text-neutral-dark block">Con CSV</span>
          <desy-input
            id="humanSupervision"
            [classes]="'w-full'"
            [placeholder]="'Supervisor-1, Supervisor-2...'"
            formControlName="humanSupervision"></desy-input>
          <desy-error-message *ngIf="getError(form, 'humanSupervision', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <div class="flex flex-col relative mt-2">
        <label
          class="text-[16px]"
          for="inputDataQuality"
          [ngClass]="{ 'relative -top-4': isObserved('inputDataQuality') }">
          Calidad de datos de entrada
          <span *ngIf="highRiskFieldsRequired()">*</span>
        </label>
        <app-observed-field-alert
          *ngIf="isObserved('inputDataQuality')"
          class="absolute top-2 left-0"></app-observed-field-alert>
      </div>
      <desy-textarea
        formControlName="inputDataQuality"
        placeholder="CSV del documento o URL de acceso al mismo del documento de medidas de calidad de los datos de entrada"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="200"></desy-textarea>
      <ng-container *ngIf="getError(form, 'inputDataQuality', formSubmitted()) as error; else inputDataQualityInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #inputDataQualityInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 200 caracteres</span>
      </ng-template>

      <div class="flex flex-col relative mt-4">
        <label
          class="text-[16px]"
          for="qualityMonitoring"
          [ngClass]="{ 'relative -top-4': isObserved('qualityMonitoring') }">
          Monitorización continua de la calidad de los datos
          <span *ngIf="highRiskFieldsRequired()">*</span>
        </label>
        <app-observed-field-alert
          *ngIf="isObserved('qualityMonitoring')"
          class="absolute top-2 left-0"></app-observed-field-alert>
      </div>
      <desy-textarea
        formControlName="qualityMonitoring"
        placeholder="Existencia sistema de monitorización para detectar automáticamente cambios o desviaciones en la calidad o distribución de los datos de entrada (Data Drift)"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="500"></desy-textarea>
      <ng-container *ngIf="getError(form, 'qualityMonitoring', formSubmitted()) as error; else qualityMonitoringInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #qualityMonitoringInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 500 caracteres</span>
      </ng-template>

      <div class="flex flex-col relative mt-4">
        <label
          class="text-[16px]"
          for="logRetention"
          [ngClass]="{ 'relative -top-4': isObserved('logRetention') }">
          Conservación de registros (Logs)
          <span *ngIf="highRiskFieldsRequired()">*</span>
        </label>
        <app-observed-field-alert
          *ngIf="isObserved('logRetention')"
          class="absolute top-2 left-0"></app-observed-field-alert>
      </div>
      <desy-textarea
        formControlName="logRetention"
        placeholder="Ubicación o URL de acceso a los logs"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="200"></desy-textarea>
      <ng-container *ngIf="getError(form, 'logRetention', formSubmitted()) as error; else logRetentionInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #logRetentionInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 200 caracteres</span>
      </ng-template>

      <div class="flex flex-col relative mt-4">
        <label
          class="text-[16px]"
          for="fria"
          [ngClass]="{ 'relative -top-4': isObserved('fria') }">
          Evaluación de Impacto sobre Derechos Fundamentales (EIDF) (Algunos actores)
          <span *ngIf="highRiskFieldsRequired()">*</span>
        </label>
        <app-observed-field-alert
          *ngIf="isObserved('fria')"
          class="absolute top-2 left-0"></app-observed-field-alert>
      </div>
      <desy-textarea
        formControlName="fria"
        placeholder="CSV del documento o URL de acceso al mismo"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="200"></desy-textarea>
      <ng-container *ngIf="getError(form, 'fria', formSubmitted()) as error; else friaInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #friaInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 200 caracteres</span>
      </ng-template>

      <div class="flex flex-col relative mt-4">
        <label
          class="text-[16px]"
          for="dpia"
          [ngClass]="{ 'relative -top-4': isObserved('dpia') }">
          EIPD
          <span *ngIf="highRiskFieldsRequired()">*</span>
        </label>
        <app-observed-field-alert
          *ngIf="isObserved('dpia')"
          class="absolute top-2 left-0"></app-observed-field-alert>
      </div>
      <desy-textarea
        formControlName="dpia"
        placeholder="CSV del documento o URL de acceso al mismo"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="200"></desy-textarea>
      <ng-container *ngIf="getError(form, 'dpia', formSubmitted()) as error; else dpiaInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #dpiaInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 200 caracteres</span>
      </ng-template>

      <div class="grid grid-cols-2 items-end mt-4">
        <div class="mr-6 flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('naturalPersonInteraction')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="naturalPersonInteraction"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('naturalPersonInteraction') }">
              Interacción directa con personas físicas*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay interacción directa
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'naturalPersonInteraction', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="ml-6 flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('contentGeneration')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="contentGeneration"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('contentGeneration') }">
              Generación de contenidos sintéticos (audio, imagen, vídeo o texto)*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay generación de contenidos
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'contentGeneration', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="mr-6 flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('biometricsEmotions')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="biometricsEmotions"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('biometricsEmotions') }">
              Reconocimiento de emociones o categorización biométrica*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay reconocimiento
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'biometricsEmotions', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="ml-6 flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('publicInterestText')"
            class="absolute top-8 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="publicInterestText"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('publicInterestText') }">
              Generación o manipulación de texto con el fin de informar al usuario sobre asuntos de interés público*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay generación o manipulación de texto
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'publicInterestText', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <div class="flex flex-col relative mt-4">
        <label
          class="text-[16px] block"
          for="userInformation"
          [ngClass]="{ 'relative -top-4': isObserved('userInformation') }">
          <span *ngIf="userInfoRequired()">
            Información sobre uso IA y medidas aplicadas para garantizar transparencia*
          </span>
          <span *ngIf="!userInfoRequired()">
            Información sobre uso IA y medidas aplicadas para garantizar transparencia
          </span>
        </label>
        <app-observed-field-alert
          *ngIf="isObserved('userInformation')"
          class="absolute top-2 left-0"></app-observed-field-alert>
      </div>
      <desy-textarea
        formControlName="userInformation"
        placeholder="Describir cómo se ha informado a las personas físicas sobre el funcionamiento del sistema y las medidas aplicadas"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="500"></desy-textarea>
      <ng-container *ngIf="getError(form, 'userInformation', formSubmitted()) as error; else userInformationInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #userInformationInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 500 caracteres</span>
      </ng-template>
    </div>
  </div>
</form>
